export enum RowDisplayType {
  Empty,
  SumSmall,
  Sum,
  Title,
  DimensionTitle,
  Dimension,
  Leaf,
}

export enum TableType {
  SupplierInvoiceList = "SIL",
  SupplierRulesList = "SRL",
  SalarySpecificationsDocumentList = "SPDL",
  PersonSalaryList = "PSL",
  SalaryDraftList = "SDL",
  QualifiedShareDividendList = "QSDL",
  OwnersList = "OL",
  HoldingRegistersList = "HR",
  HoldingRegisterAssetsList = "HRA",
  ExportItemsList = "EIL",
}
